import { queryCurrent } from '@/services/user.service';

const Model = {
  namespace: 'me',
  state: {},
  effects: {
    *fetchCurrent(_, { call, put }) {
      const response = yield call(queryCurrent);
      yield put({
        type: 'saveCurrentUser',
        payload: response,
      });
    },

    *setCurrentUser({ payload }, { put }) {
      yield put({
        type: 'saveCurrentUser',
        payload,
      });
    },
  },
  reducers: {
    saveCurrentUser(_, action) {
      return { ...action.payload };
    },
  },
};
export default Model;
